exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:992px){.btn-same-width[data-v-f5a187da]{width:100%}}", ""]);

// exports
